import http from "./../shared/axios";
import EncrDecrService from "./EncrDecrService.Service";
import { funcGenerateUniqueKey } from "../shared/utility";
import { TokenGen_Endpoint } from "../shared/ServiceCommonEndpoints";
class TokenService {

  getAuthToken(cname) {
    const tokenReq = { channel: "sprint" };
    const encryptToken = EncrDecrService.setWithPassPhrase(tokenReq, cname);
    const anonymous_id = funcGenerateUniqueKey();
    localStorage.setItem("anonymous_id", anonymous_id)
    return http.post(TokenGen_Endpoint + cname, encryptToken,
      { headers: { "Content-Type": "text/plain", "IDENTIFIER_1": anonymous_id, } },
      {
        transformRequest: (data, headers) => {
          delete headers.common['Content-Length'];
          return data;
        }
      });
  }
}
// eslint-disable-next-line
export default new TokenService();